import { render, staticRenderFns } from "./QueryObjectAdd.vue?vue&type=template&id=0131c53a"
import script from "./QueryObjectAdd.vue?vue&type=script&lang=js"
export * from "./QueryObjectAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports